<template>
	<div>
		<div class="m-d-20"
		     v-for="t in tahapan"
		     :key="t.idtahapan"
		     :id="'form-tahapan-' + t.idtahapan"
		     style="display: none"
		>
			<div class="d-flex-between-center m-d-4">
				<div class="f-semi f-14 f-c-midgrey">
					{{ t.text }}
				</div>
				<div class="f-semi font-14 f-c-blue"
				     @click="switchInput(t.idtahapan)"
				     style="margin-right: 54px"
				>
					<span v-html="(isRupiah[t.idtahapan]) ? 'Ubah ke persentase' : 'Ubah ke rupiah'"></span>
					<i class="f-14 fas fa-chevron-left"></i>
					<i class="f-14 fas fa-chevron-right"></i>
				</div>
			</div>
			<div class="d-flex-between-center">
				<InputRupiah
					:outerDivClass="'input-group remove-padding p-r-20'"
					:showRp="true"
					:placeholder="'14.000'"
					:comma="false"
					:id="'input-tahapan-' + t.idtahapan"
					v-if="isRupiah[t.idtahapan]"
					:customObject="upah[t.idtahapan].rupiah"
					:defaultValue="upah[t.idtahapan].rupiah.formatted"
					:maxAmount="hargaLayanan"
					v-model="upah[t.idtahapan].rupiah"
				/>
				<div class="input-group remove-padding p-r-20" v-if="!isRupiah[t.idtahapan]">
					<InputPersentase class="'form-control inputs'"
					                 :id="'input-persentase-tahapan-' + t.idtahapan"
					                 v-model="upah[t.idtahapan].percent.raw"
					                 @input="(val) => { convertingToRupiah(t.idtahapan, val) }"
					/>
					<div class="input-group-prepend">
						<div class="input-group-text">%</div>
					</div>
				</div>
				<img src="../../assets/icons/closesred.svg" alt=""
				     class="plus-icon hapusEnable"
				     style="display:block !important"
				     @click="removeUpahBorongan(t.idtahapan)"
				/>
			</div>
		</div>

		<div class="m-d-12"
		     v-for="t in tahapan"
		     :key="'z' + t.idtahapan"
		     :id="'tahapan-' + t.idtahapan"
		     @click="addUpahBorongan(t.idtahapan)"
		>
			<div class="f-c-blue m-d-12">
				<span class="f-semi f-16 f-c-blue m-r-8">+</span>
				<span class="f-semi f-16 f-c-blue">{{ t.text }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import InputRupiah from "@/component-items/InputRupiah";
import InputPersentase from "@/component-items/InputPersentase";

export default {
	name: "UpahBoronganComponent",
	components: {
		InputRupiah,
		InputPersentase,
	},
	props: {
		hargaLayanan: Number,
		tahapan: Array,
		upahBorongan: Object,
	},
	data() {
		return {
			isRupiah: {},
			upah: {},
		}
	},
	mounted() {
		this.setup()
	},
	watch: {
		hargaLayanan: {
			handler: function () {
				this.recalculate()
			}
		},
		tahapan: {
			handler: function () {
				this.setup()
			},
			deep: true
		},
		upahBorongan: {
			handler: function () {
				this.setup()
			},
			deep: true
		}
	},
	methods: {
		setup() {
			this.setIsRupiah()
			this.setDataUpah()
			this.$emit("upah", this.upah)
		},
		setIsRupiah() {
			for (let i = 0; i < this.tahapan.length; i++) {
				this.isRupiah[this.tahapan[i].idtahapan] = false
			}
		},
		setDataUpahDefault() {
			for (let i = 0; i < this.tahapan.length; i++) {
				this.upah[this.tahapan[i].idtahapan] = {
					rupiah: {
						idtahapan: this.tahapan[i].idtahapan,
						text: this.tahapan[i].text,
						value: 0,
						raw: 0,
						formatted: "0",
					},
					percent: {
						idtahapan: this.tahapan[i].idtahapan,
						text: this.tahapan[i].text,
						value: 0,
						raw: 0,
						formatted: "0",
					}
				}
			}
		},
		setDataUpah() {
			if (this.upahBorongan !== undefined) {
				let newUpah = {}
				for (let i = 0; i < this.tahapan.length; i++) {
					if (this.upahBorongan[this.tahapan[i].idtahapan] === undefined) {
						// run fallback
						this.setDataUpahDefault()
						this.recalculate()
						return
					}

					newUpah[this.tahapan[i].idtahapan] = {
						rupiah: {
							idtahapan: this.upahBorongan[this.tahapan[i].idtahapan].idtahapan,
							text: this.upahBorongan[this.tahapan[i].idtahapan].text,
							value: this.upahBorongan[this.tahapan[i].idtahapan].value,
							raw: this.percentToRupiah(this.hargaLayanan, parseFloat(this.upahBorongan[this.tahapan[i].idtahapan].raw)),
							formatted: this.percentToRupiah(this.hargaLayanan, parseFloat(this.upahBorongan[this.tahapan[i].idtahapan].raw)).toString(),
						},
						percent: {
							idtahapan: this.upahBorongan[this.tahapan[i].idtahapan].idtahapan,
							text: this.upahBorongan[this.tahapan[i].idtahapan].text,
							value: this.upahBorongan[this.tahapan[i].idtahapan].value,
							raw: parseFloat(this.upahBorongan[this.tahapan[i].idtahapan].raw),
							formatted: this.upahBorongan[this.tahapan[i].idtahapan].formatted,
						}
					}

					if (parseFloat(this.upahBorongan[this.tahapan[i].idtahapan].raw) !== 0) {
						$("#form-tahapan-" + this.tahapan[i].idtahapan).show();
						$("#tahapan-" + this.tahapan[i].idtahapan).hide();
					}
				}
				this.upah = newUpah;
			} else {
				this.setDataUpahDefault()
			}
		},
		setHargaLayanan(harga) {
			this.hargaLayanan = harga
		},

		addUpahBorongan(id) {
			$("#tahapan-" + id).hide();
			$("#form-tahapan-" + id).show();
			$("#input-persentase-tahapan-" + id).focus();
			$('html, body').animate({
				scrollTop: $("#form-tahapan-" + id).offset().top - 64
			}, 300);
		},
		removeUpahBorongan(id) {
			$("#tahapan-" + id).show();
			$("#form-tahapan-" + id).hide();

			this.upah[id].percent.formatted = "0"
			this.upah[id].percent.raw = 0
			this.upah[id].rupiah.formatted = "0"
			this.upah[id].rupiah.raw = 0
		},
		switchInput(id) {
			let clone = JSON.parse(JSON.stringify(this.isRupiah))
			if (clone[id]) {
				let val = this.upah[id].rupiah.raw
				this.upah[id].percent.formatted = this.rupiahToPrecent(this.hargaLayanan, val).toString().replace(".", ",")
				this.upah[id].percent.raw = this.rupiahToPrecent(this.hargaLayanan, val)
			} else {
				let val = this.upah[id].percent.raw
				this.upah[id].rupiah.formatted = this.percentToRupiah(this.hargaLayanan, val).toString().replace(".", ",")
				this.upah[id].rupiah.raw = this.percentToRupiah(this.hargaLayanan, val)
			}
			clone[id] = !clone[id]
			this.isRupiah = clone

			this.$emit("upah", this.upah)
		},
		convertingToRupiah(id, val) {
			this.upah[id].percent.formatted = val.formatted
			this.upah[id].percent.raw = val.raw

			this.upah[id].rupiah.formatted = this.percentToRupiah(this.hargaLayanan, val.raw).toString().replace(".", ",")
			this.upah[id].rupiah.raw = this.percentToRupiah(this.hargaLayanan, val.raw)

			this.$emit("upah", this.upah)
		},
		recalculate() {
			for (let i = 0; i < this.tahapan.length; i++) {
				let id = this.tahapan[i].idtahapan
				// acuan persen

				this.upah[id].rupiah.formatted = this.percentToRupiah(this.hargaLayanan, this.upah[id].percent.raw).toString().replace();
				this.upah[id].rupiah.raw = this.percentToRupiah(this.hargaLayanan, this.upah[id].percent.raw)
			}
		},

		rupiahToPrecent(harga, upah) {
			let fUpah = parseFloat(upah)
			let fHarga = parseFloat(harga)
			return (isNaN(fUpah)) ? 0 : parseFloat((fUpah / fHarga * 100).toFixed(2))
		},
		percentToRupiah(harga, upah) {
			let fUpah = parseFloat(upah)
			let fHarga = parseFloat(harga)
			return (isNaN(fUpah)) ? 0 : Math.round((fUpah / 100) * fHarga)
		},
	}
}
</script>